import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { fetchProgramsStats } from "../../../../../utils/axios";
import { AlertCircle, Info, X } from "lucide-react";
import SubmissionRateChart from "../SubmissionRateComponents/SubmissionRateChart";

const ProgramStatsGaugeChart = () => {
  const [stats, setStats] = useState({
    submissionRate: 0,
    totalSubmissions: 0,
    validSubmissions: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const currentValue = stats.submissionRate;

  let progressColor = "#e74c3c";
  if (currentValue <= 30) {
    progressColor = "#f39c12";
  } else if (currentValue <= 70) {
    progressColor = "#16a085";
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await fetchProgramsStats();

        // Calculate submission rate using the formula
        const rate =
          data.total_submissions > 0
            ? (data.total_valid_submissions / data.total_submissions) * 100
            : 0;

        setStats({
          submissionRate: parseFloat(rate.toFixed(2)),
          totalSubmissions: data.total_submissions,
          validSubmissions: data.total_valid_submissions,
        });
        setLoading(false);
      } catch (err) {
        setError("Failed to load data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getOption = () => {
    const currentValue = stats.submissionRate;

    let progressColor = "#D8B4F8";
    if (currentValue <= 30) {
      progressColor = "#FF6B6B";
    } else if (currentValue <= 70) {
      progressColor = "#7851A9";
    }

    return {
      backgroundColor: "transparent",
      tooltip: {
        formatter: "{a} <br/>{b} : {c}%",
      },
      series: [
        {
          name: "Submission Rate",
          type: "gauge",
          radius: "90%",
          center: ["50%", "80%"],
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 100,
          splitNumber: 10,
          axisLine: {
            lineStyle: {
              width: 18,
              color: [
                [1, "#E0E0E0"], // Light grey base (background arc)
              ],
            },
          },
          progress: {
            show: true,
            width: 18,
            roundCap: true,
            clip: false,
            itemStyle: {
              color: "#7851A9", // Royal Purple progress
              shadowColor: "rgba(112, 0, 250, 0.5)", // Glow effect (soft purple glow)
              shadowBlur: 10,
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            distance: -18,
            length: 18,
            lineStyle: {
              color: "#fff",
              width: 2,
            },
          },
          axisLabel: {
            show: false,
          },
          pointer: {
            show: true,
            width: 6,
            length: "70%",
            offsetCenter: [0, 0],
            itemStyle: {
              color: "#2f4554",
            },
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 14,
            itemStyle: {
              borderWidth: 6,
              color: " #2f4554",
              borderColor: "#fff",
            },
          },
          detail: {
            valueAnimation: true,
            fontSize: 20,
            fontWeight: "bold",
            color: "#333",
            offsetCenter: [0, "34%"],
            formatter: "{value}%",
          },
          data: [
            {
              value: stats.submissionRate,
            },
          ],
        },
      ],
    };
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-80 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <div className="w-14 h-14 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600 font-medium">Loading data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-80 bg-white rounded-xl shadow-lg">
        <div className="text-center text-red-500">
          <AlertCircle size={56} className="mx-auto mb-3" />
          <p className="font-medium">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl relative">
      <div className="relative">
        <div className="mb-2">
          <SubmissionRateChart />
        </div>
        <div>
          <ReactECharts
            option={getOption()}
            style={{ height: "160px", width: "80%" }}
            className="mx-auto"
          />
          <h6 className="mt-3 text-center">Average Customer Satisfaction</h6>
        </div>
      </div>
    </div>
  );
};

export default ProgramStatsGaugeChart;
